<template>
    <div class="container admin-table-page">

        <!-- ==================== TÍTULO ==================== -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button
                        class="page-back-btn mr-2"
                        variant="link"
                        @click="goBack"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'arrow-alt-circle-left']"
                            class="back-icon"
                        />
                    </b-button>

                    <h2 class="param-title">
                        {{ tituloConsolidado || labels.title }}
                    </h2>
                </div>
            </div>
        </div>


        <!-- ==================== FILTROS ==================== -->
        <div class="param-title-wrap niif-header">
            <div
                class="d-flex align-items-center w-100"
                style="flex-wrap: wrap; gap: 8px;"
            >

                <!-- Filtros principales -->
                <div
                    class="filters-container d-flex align-items-center"
                    style="flex-wrap: wrap; gap: 8px;"
                >

                    <!-- Reporte -->
                    <b-form-select
                        v-model="dialogReportes"
                        @change="onFiltroChange"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>

                        <option
                            v-for="reporte in reportes"
                            :key="reporte.id"
                            :value="reporte.codigo"
                        >
                            {{ reporte?.nombre }}
                        </option>
                    </b-form-select>


                    <!-- Vigencia -->
                    <b-form-select
                        v-model="dialogFechas"
                        @change="onFiltroChange"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectValidity }}
                        </b-form-select-option>

                        <option
                            v-for="fecha in fechas"
                            :key="fecha.fecha"
                            :value="fecha.fecha"
                        >
                            {{ fecha?.fecha }}
                        </option>
                    </b-form-select>


                    <!-- Grupo -->
                    <b-form-select
                        v-model="grupoId"
                        @change="filtraCompaniasPorGrupo()"
                        class="filter-select"
                    >
                        <option value="todos">
                            {{ labels.allGroups }}
                        </option>

                        <option
                            v-for="grupo in listGrupos"
                            :key="'grupo-' + grupo.id"
                            :value="grupo.id"
                        >
                            {{ grupo?.nombre }}
                        </option>
                    </b-form-select>


                    <!-- Compañía -->
                    <b-form-select
                        v-model="dialogCompanias"
                        @change="seleccionaCompania()"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectCompany }}
                        </b-form-select-option>

                        <option
                            v-for="compania in companiasFiltradas"
                            :key="compania.id"
                            :value="compania.id"
                        >
                            {{ compania?.acronym ? compania?.acronym + ' ' : '' }}
                            {{ compania?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Dropdown de selección única para vistas -->
                    <b-dropdown
                        variant="outline-secondary"
                        class="filter-dropdown"
                        toggle-class="filter-dropdown-btn"
                        :text="selectedViewOptionText"
                    >
                        <!-- Grupo Reportes -->
                        <b-dropdown-header>Reportes</b-dropdown-header>
                        <b-dropdown-item
                            v-for="option in viewOptions.filter(o => o.group === 'Reportes')"
                            :key="option.value"
                            @click="selectViewOption(option.value)"
                            :active="selectedViewOption === option.value"
                        >
                            {{ option.text }}
                        </b-dropdown-item>
                        
                        <b-dropdown-divider></b-dropdown-divider>
                        
                        <!-- Grupo Información -->
                        <b-dropdown-header>Información</b-dropdown-header>
                        <b-dropdown-item
                            v-for="option in viewOptions.filter(o => o.group === 'Información')"
                            :key="option.value"
                            @click="selectViewOption(option.value)"
                            :active="selectedViewOption === option.value"
                        >
                            {{ option.text }}
                        </b-dropdown-item>
                    </b-dropdown>

                </div>


                <!-- Botones -->
                <div class="filters-container d-flex align-items-center">

                    <!-- Generar -->
                    <b-button
                        class="consult-btn"
                        @click="generar"
                        :disabled="
                            !dialogFechas ||
                            !dialogReportes ||
                            !dialogCompanias ||
                            !selectedViewOption
                        "
                    >
                        <font-awesome-icon
                            :icon="['fas', 'search']"
                            class="mr-1"
                        />

                        {{ labels.generar }}
                    </b-button>

                </div>

            </div>
        </div>


        <!-- ==================== MODAL SELECCIÓN DE EMPRESAS PARA REPORTE CONSOL ==================== -->
        <b-modal
            v-model="showEmpresasModal"
            :title="labels.selectCompanies"
            size="lg"
            @hidden="showEmpresasModal = false"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-ajuste-dialog"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title" style="font-size: 16px; font-weight: 600; color: #2e507a;">
                        {{ labels.selectCompaniesTitle }}
                    </div>
                    <div class="password-policy-subtitle" style="font-size: 14px; color: #6c757d;">
                        {{ labels.selectCompaniesSubtitle }}
                    </div>
                </div>

                <!-- Lista de empresas -->
                <div class="accounts-section mt-2">
                    <div v-if="companiasFiltradas.length > 0" class="accounts-list mt-1">
                        <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                            <b-button
                                size="sm"
                                style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                @click="toggleSelectAllCompaniesModal"
                            >
                                {{ selectAllCompaniesModal ? labels.deselectAll : labels.selectAll }}
                            </b-button>
                            <span style="font-size: 13px; color: #6c757d;">
                                {{ labels.selected }}: <strong>{{ EmpresasConsolida.length }}</strong> / {{ companiasFiltradas.length }}
                            </span>
                        </div>

                        <div class="custom-scroll-table" style="min-height: 250px; height: auto; max-height: 350px; overflow-y: auto;">
                            <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                    <tr>
                                        <th style="width: 100px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                            {{ labels.code }}
                                        </th>
                                        <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                            {{ labels.companyName }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="compania in companiasFiltradas"
                                        :key="compania.id"
                                        @click="toggleCompanySelectionModal(compania)"
                                        :class="{'table-active-blue': isCompanySelectedModal(compania)}"
                                        style="cursor: pointer; border-radius: 8px;"
                                    >
                                        <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                            <strong>{{ compania?.acronym || compania?.codigo || '' }}</strong>
                                        </td>
                                        <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="compania.nombre">
                                            {{ compania?.nombre }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-else class="text-center py-4" style="height: 250px; display: flex; align-items: center; justify-content: center;">
                        <span class="text-muted" style="font-size: 13px;">{{ labels.noCompaniesAvailable }}</span>
                    </div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button
                        class="mr-2 reset-btn-secondary"
                        @click="closeEmpresasModal"
                        :disabled="isSavingCompanies"
                        style="font-size: 14px; padding: 6px 24px;"
                    >
                        {{ labels.close }}
                    </b-button>
                    <b-button
                        class="reset-btn-primary"
                        @click="confirmEmpresasSelectionModal"
                        :disabled="isSavingCompanies || EmpresasConsolida.length === 0"
                        style="font-size: 14px; padding: 6px 24px;"
                    >
                        {{ labels.confirmSelection }}
                    </b-button>
                </div>
            </div>
        </b-modal>


        <!-- ========================================================= -->
        <!-- ==================== CONTENIDO PRINCIPAL ================= -->
        <!-- ========================================================= -->
        <div class="admin-table-block mt-4">

            <!-- ==================== REPORTE ==================== -->
            <div v-if="Reporte">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="reporteFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="reporteFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(5)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>


            <!-- ==================== REPORTE CONSOL ==================== -->
            <div v-if="ReporteConsol">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="reporteFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="reporteFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right d-flex align-items-center" style="gap: 8px; flex-wrap: wrap;">

                            <!-- Selector de moneda -->
                            <b-form-select
                                v-if="mostrarSelectorMonedaConsolidado"
                                v-model="monedaConsolidadoSeleccion"
                                @change="onCambioMonedaConsolidado"
                                class="form-control form-control-sm"
                                style="min-width: 165px; max-width: 165px;"
                            >
                                <option
                                    v-for="option in monedaConsolidadoOptions"
                                    :key="'reporte-' + option.value"
                                    :value="option.value"
                                >
                                    {{ option?.text }}
                                </option>
                            </b-form-select>

                            <!-- Botones de Reporte Consol -->
                            <div class="reporte-consol-tabs-wrapper">
                                <b-button
                                    :class="
                                        consol && !fgl_combinado
                                            ? 'tab-btn-origin-dest tab-active'
                                            : 'tab-btn-origin-dest tab-inactive'
                                    "
                                    @click="cambiaConsolidacion"
                                    :disabled="!searched || searched.length === 0"
                                >
                                    {{ labels.consolidated }}
                                </b-button>

                                <b-button
                                    :class="
                                        !consol && !fgl_combinado
                                            ? 'tab-btn-origin-dest tab-active'
                                            : 'tab-btn-origin-dest tab-inactive'
                                    "
                                    @click="cambiaAjuste"
                                    :disabled="!ajustes || ajustes.length === 0"
                                >
                                    {{ labels.adjustments }}
                                </b-button>

                                <b-button
                                    :class="
                                        consol && fgl_combinado
                                            ? 'tab-btn-origin-dest tab-active'
                                            : 'tab-btn-origin-dest tab-inactive'
                                    "
                                    @click="cambiaCombinado"
                                    :disabled="!combinado || combinado.length === 0"
                                >
                                    {{ labels.combined }}
                                </b-button>

                                <b-button
                                    :class="
                                        !consol && fgl_combinado
                                            ? 'tab-btn-origin-dest tab-active'
                                            : 'tab-btn-origin-dest tab-inactive'
                                    "
                                    @click="cambiaAjusteCombinado"
                                    :disabled="
                                        !ajustesCombinado ||
                                        ajustesCombinado.length === 0
                                    "
                                >
                                    {{ labels.combinedAdjustments }}
                                </b-button>
                            </div>

                            <!-- Exportar Excel -->
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(5)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>

                        </div>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>


            <!-- ==================== INFORMACIÓN (VALOR MANUAL) ==================== -->
            <div v-if="Informacion">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(4)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEdit)="data">
                    <b-button
                        style="background-color: #FF924C; width: 30px; height: 30px;"
                        class="md-fab md-primary table-action-btn"
                        @click="f_muestra([data.item])"
                        :disabled="isVigenciaBloqueada"
                    >
                        <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                    </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>


            <!-- ==================== AJUSTE CONSOL ==================== -->
            <div v-if="InfAjusteConsol">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(6)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <!-- Columna de edición para Ajuste Consol -->
                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px; padding: 0; border-radius: 50%; border: none;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestraConsol([data.item])"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>


            <!-- ==================== AJUSTE COMBINADO ==================== -->
            <div v-if="InfAjusteComb">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(7)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <!-- Columna de edición para Ajuste Combinado -->
                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px; padding: 0; border-radius: 50%; border: none;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestraComb([data.item])"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>


            <!-- ========================================================= -->
            <!-- ==================== SIN SELECCIÓN ====================== -->
            <!-- ========================================================= -->
            <div
                v-if="
                    !Reporte &&
                    !ReporteConsol &&
                    !Informacion &&
                    !InfAjusteConsol &&
                    !InfAjusteComb
                "
            >
                <CorporateDataTable
                    :items="[]"
                    :fields="[]"
                    :labels="tableLabels"
                    :loading="false"
                    :default-per-page="10"
                    :page-options="[10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="false"
                    :allow-column-toggle="false"
                    :enable-sorting="false"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #empty-state>
                        <div class="text-center py-5">
                            <img
                                src="../../assets/imgs/file-2.svg"
                                alt="warning"
                                class="mb-3"
                                style="opacity: 0.3; width: 80px;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.selectCriteria }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

        </div>


        <!-- ==================== MODAL CUENTAS ==================== -->
        <b-modal
            v-model="showDialog"
            :title="f1_titulo()"
            size="lg"
            @hidden="showDialog = false"
            header-class="modal-header-custom"
            footer-class="modal-footer-custom"
        >
            <CorporateDataTable
                :items="cuentas"
                :fields="cuentasFields"
                :labels="tableLabels"
                :loading="false"
                :default-per-page="cuentas.length || 10"
                :page-options="[cuentas.length || 10]"
                :narrow="false"
                :table-min-height="300"
                :table-max-height="400"
                :show-search="true"
                :allow-column-toggle="true"
                :enable-sorting="true"
                :show-pagination="false"
                :show-rows-per-page="false"
            />

            <template #footer>
                <b-button
                    variant="secondary"
                    @click="showDialog = false"
                >
                    {{ labels.close }}
                </b-button>
            </template>
        </b-modal>


        <!-- ==================== MODAL INFORMACIÓN (VALOR MANUAL) ==================== -->
        <b-modal
            v-model="showDialogInformacion"
            :title="labels.informacion"
            @hidden="showDialogInformacion = false"
            header-class="modal-header-custom"
            footer-class="modal-footer-custom"
            size="md"
        >
            <b-form @submit.prevent="f_grabaInformacion">
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.fila }}</label>
                        <b-form-input
                            v-model="formInformacion.fila_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.columna }}</label>
                        <b-form-input
                            v-model="formInformacion.columna_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.monto }}</label>
                        <b-form-input
                            v-model="formInformacion.valor"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.funcional }}</label>
                        <b-form-input
                            v-model="formInformacion.funcional1"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                        />
                    </b-col>
                </b-row>
            </b-form>

            <template #footer>
                <b-button
                    variant="primary"
                    @click="f_grabaInformacion()"
                    :disabled="isVigenciaBloqueada"
                >
                    {{ labels.save }}
                </b-button>
                <b-button
                    variant="secondary"
                    @click="showDialogInformacion = false"
                >
                    {{ labels.close }}
                </b-button>
            </template>
        </b-modal>


        <!-- ==================== MODAL INFORMACIÓN CONSOLIDADA ==================== -->
        <b-modal
            v-model="showDialogInformacionConsol"
            :title="labels.informacionConsolidada"
            @hidden="showDialogInformacionConsol = false"
            header-class="modal-header-custom"
            footer-class="modal-footer-custom"
            size="md"
        >
            <b-form @submit.prevent="f_grabaInformacionConsol">
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.fila }}</label>
                        <b-form-input
                            v-model="formInformacionConsol.fila_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.columna }}</label>
                        <b-form-input
                            v-model="formInformacionConsol.columna_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.monto }}</label>
                        <b-form-input
                            v-model="formInformacionConsol.valor"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.funcional1 }}</label>
                        <b-form-input
                            v-model="formInformacionConsol.funcional1"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                        />
                    </b-col>
                </b-row>
            </b-form>

            <template #footer>
                <b-button
                    variant="primary"
                    @click="f_grabaInformacionConsol()"
                    :disabled="isVigenciaBloqueada"
                >
                    {{ labels.save }}
                </b-button>
                <b-button
                    variant="secondary"
                    @click="showDialogInformacionConsol = false"
                >
                    {{ labels.close }}
                </b-button>
            </template>
        </b-modal>


        <!-- ==================== MODAL INFORMACIÓN COMBINADA ==================== -->
        <b-modal
            v-model="showDialogInformacionComb"
            :title="labels.informacionCombinacion"
            @hidden="showDialogInformacionComb = false"
            header-class="modal-header-custom"
            footer-class="modal-footer-custom"
            size="md"
        >
            <b-form @submit.prevent="f_grabaInformacionComb">
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.fila }}</label>
                        <b-form-input
                            v-model="formInformacionComb.fila_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.columna }}</label>
                        <b-form-input
                            v-model="formInformacionComb.columna_desc"
                            disabled
                            class="bg-light"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.monto }}</label>
                        <b-form-input
                            v-model="formInformacionComb.valor"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col>
                        <label class="font-weight-bold">{{ labels.funcional1 }}</label>
                        <b-form-input
                            v-model="formInformacionComb.funcional1"
                            type="number"
                            step="0.01"
                            class="form-control"
                            :disabled="isVigenciaBloqueada"
                        />
                    </b-col>
                </b-row>
            </b-form>

            <template #footer>
                <b-button
                    variant="primary"
                    @click="f_grabaInformacionComb()"
                    :disabled="isVigenciaBloqueada"
                >
                    {{ labels.save }}
                </b-button>
                <b-button
                    variant="secondary"
                    @click="showDialogInformacionComb = false"
                >
                    {{ labels.close }}
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import Balance from "@/services/BalanceNiif"
import Currency from "@/services/Currency"
import BotonesControl from "@/services/BotonesControl"
import Grupo from "@/services/Grupo"
import CorporateDataTable from '../utils/CorporateDataTable.vue'

export default {
    name: "ReporteECP",
    components: {
        CorporateDataTable
    },
    data: () => ({
        selectedViewOption: null,
        viewOptions: [
            // Grupo "Reportes"
            { value: 'reporte', text: 'Reporte', group: 'Reportes' },
            { value: 'reporteConsol', text: 'Reporte Consol', group: 'Reportes' },
            // Grupo "Información"
            { value: 'informacion', text: 'Valor Manual', group: 'Información' },
            { value: 'ajusteConsol', text: 'Ajuste Consol', group: 'Información' },
            { value: 'ajusteComb', text: 'Ajuste Combinado', group: 'Información' }
        ],
        
        // Modal de empresas
        showEmpresasModal: false,
        selectAllCompaniesModal: false,
        isSavingCompanies: false,
        pendingGenerate: false,
        fromButtonGenerate: false,
        
        InfAjusteConsol: false,
        InfAjusteComb: false,
        showDialogInformacionConsol: false,
        showDialogInformacionComb: false,
        formInformacionConsol: { fila: '', fila_desc: '', columna: '', columna_desc: '', valor: '', funcional1: '', u_modifica: '' },
        formInformacionComb: { fila: '', fila_desc: '', columna: '', columna_desc: '', valor: '', funcional1: '', u_modifica: '' },
        formCuentas: {},
        showDialog: false,
        showDialogInformacion: false,
        dialogItem: {},
        balance: [],
        ajustes: [],
        combinado: [],
        ajustesCombinado: [],
        cuentas: [],
        searched: [],
        isEmpty: true,
        isLoading: false,
        fgl_excel: true,
        error: false,
        formInformacion: { fila: '', fila_desc: '', columna: '', columna_desc: '', valor: '', funcional1: '', u_modifica: '' },
        idCompania: 0,
        vigencia: '',
        codReporte: '',
        Reporte: false,
        ReporteConsol: false,
        Notas: false,
        Informacion: false,
        companias: [],
        companiasFiltradas: [],
        companiaUsuario: [],
        dialogCompanias: '',
        EmpresasConsolida: [],
        selectAllCompanies: false,
        empresasSeleccion: false,
        fechas: [],
        dialogReportes: '',
        reportes: [],
        dialogFechas: '',
        columnas: 0,
        titulo_columna: [],
        titulo_columna_ecp: [],
        empresa: 0,
        generado: false,
        codigoCompanias: "",
        moneda: '',
        ecpfilas: [],
        ecpcolumnas: [],
        maxcolumnas: 0,
        rutaExcel: '',
        path: '',
        consol: true,
        fgl_combinado: false,
        tituloConsolidado: "",
        listGrupos: [],
        grupoId: 'todos',
        currency: [],
        monedaConsolidadoSeleccion: 'funcional1',
    }),
    computed: {
        selectedViewOptionText() {
            if (!this.selectedViewOption) return this.$store.state._language == "es-ES" ? "Seleccione Vista" : "Select View"
            const option = this.viewOptions.find(opt => opt.value === this.selectedViewOption)
            return option ? option.text : this.$store.state._language == "es-ES" ? "Seleccione Vista" : "Select View"
        },
        isVigenciaBloqueada() {
            return this.dialogFechas ? !this.$store.getters.isPeriodoEnabled(this.dialogFechas) : false
        },
        balanceFiltrado() {
            if (!this.balance || this.balance.length === 0) return []
            return this.balance
        },
        isSelectorMonedaVisible() {
            return this.$store.getters.isControlVisible('ReporteECP', 'SelectorMoneda')
        },
        isMonedaFuncional1Visible() {
            return this.$store.getters.isControlVisible('ReporteECP', 'MonedaFuncional1')
        },
        isMonedaFuncional2Visible() {
            return this.$store.getters.isControlVisible('ReporteECP', 'MonedaFuncional2')
        },
        monedaConsolidadoOptions() {
            const options = []
            const moneda1 = this.getNombreMonedaConsolidado('funcional1')
            const moneda2 = this.getNombreMonedaConsolidado('funcional2')
            if (this.isMonedaFuncional1Visible && moneda1) {
                options.push({ value: 'funcional1', text: moneda1 })
            }
            if (this.isMonedaFuncional2Visible && moneda2) {
                options.push({ value: 'funcional2', text: moneda2 })
            }
            return options
        },
        mostrarSelectorMonedaConsolidado() {
            return this.ReporteConsol &&
                this.isSelectorMonedaVisible &&
                this.monedaConsolidadoOptions.length > 1
        },
        labels() {
            const es = this.$store.state._language == "es-ES"
            return {
                title: es ? "Estado de cambios en el Patrimonio" : "CHANGE IN EQUITY",
                selectReport: es ? "Seleccione Reporte" : "Select Report",
                selectValidity: es ? "Seleccione Vigencia" : "Select Validity",
                selectCompany: es ? "Seleccione Compañía" : "Select Company",
                allGroups: es ? "Todos los grupos" : "All groups",
                reporte: es ? "Reporte" : "Report",
                reporteConsol: es ? "Reporte Consol" : "Report Consol",
                informacion: es ? "Valor Manual" : "Manual Value",
                ajusteConsol: es ? "Ajuste Consol" : "Consol Adjustment",
                ajusteComb: es ? "Ajuste Combinado" : "Combined Adjustment",
                empresas: es ? "Empresas" : "Companies",
                selectCompanies: es ? "Empresas para consolidar" : "Companies to consolidate",
                selectCompaniesTitle: es ? "Selección de empresas" : "Company Selection",
                selectCompaniesSubtitle: es ? "Seleccione las empresas que desea consolidar" : "Select the companies you want to consolidate",
                code: es ? "Código" : "Code",
                companyName: es ? "Nombre" : "Name",
                confirmSelection: es ? "Confirmar selección" : "Confirm selection",
                noCompaniesAvailable: es ? "No hay empresas disponibles" : "No companies available",
                selectAll: es ? "Seleccionar todas" : "Select all",
                deselectAll: es ? "Deseleccionar todas" : "Deselect all",
                selected: es ? "Seleccionadas" : "Selected",
                hideSelection: es ? "Ocultar selección" : "Hide selection",
                consolidated: es ? "Consolidado" : "Consolidated",
                adjustments: es ? "Ajustes" : "Adjustments",
                combined: es ? "Combinado" : "Combined",
                combinedAdjustments: es ? "Ajustes combinado" : "Combined Adjustments",
                descripcion: es ? "Descripcion" : "Description",
                saldo_actual: es ? "Saldo" : "Balance",
                funcional1: es ? "Funcional" : "Functional",
                promedio1: es ? "Promedio" : "Average",
                funcional2: es ? "Alterna" : "Alternative",
                promedio2: es ? "Promedio" : "Average",
                diferencia: es ? "Diferencia" : "Difference",
                funcional_dif: es ? "Dif Funcional" : "Dif Functional",
                empty: es ? "Sin Información" : "Without Information",
                generar: es ? "Generar" : "Generate",
                ajustes: es ? "Ajustes" : "Settings",
                moneda: es ? "Moneda" : "Currency",
                fila: es ? "Fila" : "Row",
                columna: es ? "Columna" : "Column",
                monto: es ? "Valor" : "Amount",
                funcional: es ? "Funcional" : "Functional",
                filacolumna: es ? "Fila / Columna" : "Row / Column",
                nota: es ? "Nota" : "Note",
                cuenta: es ? "Cuenta" : "Account",
                descripcion_cuenta: es ? "Descripción" : "Description",
                informacionConsolidada: es ? "Ajustes de Consolidacion" : "Consolidate Adjustment",
                informacionCombinacion: es ? "Ajustes de Combinacion" : "Combination Adjustment",
                exportExcel: es ? "Exportar Excel" : "Export Excel",
                loading: es ? "Cargando..." : "Loading...",
                selectCriteria: es ? "Seleccione un reporte, vigencia y compañía para generar la información" : "Select a report, validity and company to generate the information",
                save: es ? "Guardar" : "Save",
                close: es ? "Cerrar" : "Close",
                noSort: es ? "Sin orden" : "No sorting",
                sortAsc: es ? "A-Z / Menor a mayor" : "A-Z / Low to high",
                sortDesc: es ? "Z-A / Mayor a menor" : "Z-A / High to low",
                columns: es ? "Columnas" : "Columns",
                showAllColumns: es ? "Mostrar todas" : "Show all",
                filters: es ? "Filtros" : "Filters",
                clearFilters: es ? "Limpiar filtros" : "Clear filters",
                rowsPerPage: es ? "Filas por página:" : "Rows per page:",
                searchPlaceholder: es ? "Buscar en la tabla..." : "Search in table...",
                noData: es ? "No hay datos disponibles" : "No data available",
                noMatches: es ? "No se encontraron resultados" : "No results found",
                edit: es ? "Editar" : "Edit",
            }
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        reporteFields() {
            const fields = [
                { 
                    key: 'fila', 
                    label: this.labels.filacolumna, 
                    sortable: true, 
                    thClass: 'text-left', 
                    tdClass: 'text-left align-middle', 
                    minWidth: '250px',
                    formatter: (value) => this.f_fila(value)
                }
            ]
            for (let i = 1; i <= this.maxcolumnas; i++) {
                const label = this.titulo_columna_ecp[i - 1] || `Columna ${i}`
                fields.push({ 
                    key: this.getCampoValorReporteEcp(i), 
                    label: label, 
                    sortable: true, 
                    thClass: 'text-right', 
                    tdClass: 'text-right align-middle', 
                    minWidth: '150px',
                    formatter: (value) => this.formato(value)
                })
            }
            return fields
        },
        reporteFilterDefs() {
            return [
                { key: 'fila', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar fila...' : 'Filter row...' }
            ]
        },
        informacionFields() {
            return [
                { key: 'fila_desc', label: this.labels.fila, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '200px' },
                { key: 'columna_desc', label: this.labels.columna, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '200px' },
                { key: 'valor', label: this.labels.monto, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'funcional1', label: this.labels.funcional1, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '60px' }
            ]
        },
        informacionFilterDefs() {
            return [
                { key: 'fila_desc', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar fila...' : 'Filter row...' },
                { key: 'columna_desc', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar columna...' : 'Filter column...' }
            ]
        },
        cuentasFields() {
            return [
                { key: 'cuenta', label: this.labels.cuenta, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '150px' },
                { key: 'descripcion', label: this.labels.descripcion_cuenta, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
                { key: 'saldo_actual', label: this.labels.saldo_actual, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'funcional1', label: this.labels.funcional1, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'promedio1', label: this.labels.promedio1, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'funcional2', label: this.labels.funcional2, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
                { key: 'promedio2', label: this.labels.promedio2, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) }
            ]
        }
    },
    methods: {
        selectViewOption(value) {
            this.selectedViewOption = value
            this.onFiltroChange()
            
            if (value !== 'reporteConsol') {
                this.empresasSeleccion = false
                this.EmpresasConsolida = []
            }
            
            this.Reporte = false
            this.ReporteConsol = false
            this.Informacion = false
            this.InfAjusteConsol = false
            this.InfAjusteComb = false
            
            switch(value) {
                case 'reporte':
                    this.Reporte = true
                    break
                case 'reporteConsol':
                    this.ReporteConsol = true
                    break
                case 'informacion':
                    this.Informacion = true
                    break
                case 'ajusteConsol':
                    this.InfAjusteConsol = true
                    break
                case 'ajusteComb':
                    this.InfAjusteComb = true
                    break
            }
            
            // Actualizar título fijo
            this.f_titulo()
        },
        
        // ==== Métodos para el modal de empresas ====
        
        isCompanySelectedModal(compania) {
            return this.EmpresasConsolida.includes(compania.id)
        },

        toggleCompanySelectionModal(compania) {
            const index = this.EmpresasConsolida.indexOf(compania.id)
            if (index > -1) {
                this.EmpresasConsolida.splice(index, 1)
            } else {
                this.EmpresasConsolida.push(compania.id)
            }
            this.updateSelectAllCompaniesModal()
        },

        toggleSelectAllCompaniesModal() {
            this.selectAllCompaniesModal = !this.selectAllCompaniesModal
            if (this.selectAllCompaniesModal) {
                const selectedIds = this.companiasFiltradas.map(c => c.id)
                selectedIds.forEach(id => {
                    if (!this.EmpresasConsolida.includes(id)) {
                        this.EmpresasConsolida.push(id)
                    }
                })
            } else {
                const filteredIds = this.companiasFiltradas.map(c => c.id)
                this.EmpresasConsolida = this.EmpresasConsolida.filter(id => !filteredIds.includes(id))
            }
        },

        updateSelectAllCompaniesModal() {
            if (this.companiasFiltradas.length === 0) {
                this.selectAllCompaniesModal = false
                return
            }
            this.selectAllCompaniesModal = this.companiasFiltradas.every(c => this.EmpresasConsolida.includes(c.id))
        },

        openEmpresasModal() {
            this.prepararNuevaSeleccionEmpresas()
            this.showEmpresasModal = true
            this.updateSelectAllCompaniesModal()
        },

        closeEmpresasModal() {
            if (this.isSavingCompanies) return
            this.showEmpresasModal = false
        },

        confirmEmpresasSelectionModal() {
            if (this.isSavingCompanies) return
            if (this.EmpresasConsolida.length === 0) {
                this.$toast.warning(
                    this.$store.state._language == "es-ES" 
                        ? "Por favor seleccione al menos una empresa" 
                        : "Please select at least one company"
                )
                return
            }
            this.isSavingCompanies = true
            this.showEmpresasModal = false
            this.empresasSeleccion = true
            this.isSavingCompanies = false
            
            this.balance = []
            this.searched = []
            this.ajustes = []
            this.combinado = []
            this.ajustesCombinado = []
            
            setTimeout(() => {
                this.generar()
            }, 300)
        },

        prepararNuevaSeleccionEmpresas() {
            this.EmpresasConsolida = []
            this.empresasSeleccion = false
            this.selectAllCompaniesModal = false
            this.pendingGenerate = false
            this.error = false
        },
        
        // ==== Método principal generar ====
        generar() {
            // Si es Reporte Consol y no hay empresas seleccionadas, abrir modal
            if (this.selectedViewOption === 'reporteConsol' && !this.empresasSeleccion) {
                this.fromButtonGenerate = true
                this.openEmpresasModal()
                return
            }

            // Validaciones generales
            if (!this.dialogFechas) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione una vigencia" : "Please select a validity")
                return
            }
            if (!this.dialogReportes) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione un reporte" : "Please select a report")
                return
            }
            if (!this.dialogCompanias) {
                this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione una compañía" : "Please select a company")
                return
            }
            
            this.isLoading = true
            this.idCompania = this.dialogCompanias
            this.vigencia = this.dialogFechas
            this.codReporte = this.dialogReportes
            this.isEmpty = true
            this.generado = false
            this.consol = true
            this.fgl_combinado = false
            
            const empresasSeleccionadas = [...this.EmpresasConsolida]
            const hayEmpresasSeleccionadas = this.empresasSeleccion && empresasSeleccionadas.length > 0
            
            switch (this.$route.name) {
                case "reporteEcp":
                    // ===== REPORTE =====
                    if (this.Reporte) {
                        Balance.getReporteEcpFinal(this.idCompania, this.vigencia, this.codReporte)
                            .then((result) => {
                                this.balance = result.data.reporteEcp
                                this.searched = this.balance
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false
                                    this.generado = true
                                    this.f_columnas_ecp()
                                }
                                this.isLoading = false
                            })
                            .catch((error) => {
                                console.error("Error en Reporte:", error)
                                this.error = true
                                this.isLoading = false
                                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar reporte" : "Error loading report")
                            })
                    }
                    
                    // ===== REPORTE CONSOL =====
                    if (this.ReporteConsol) {
                        let empresasParam = []
                        if (!hayEmpresasSeleccionadas) {
                            empresasParam = [parseInt(this.idCompania)]
                        } else {
                            empresasParam = empresasSeleccionadas.map(id => parseInt(id))
                        }
                        
                        Balance.getReporteEcpFinalConsol(
                            empresasParam,
                            this.vigencia,
                            this.codReporte,
                            this.getMonedaConsolidadoParametro()
                        )
                            .then((result) => {
                                this.balance = result.data.reporteEcp
                                this.ajustes = result.data.ajustesEcp || result.data.ajustesECP || []
                                this.combinado = result.data.combinadoECP || result.data.combinadoEcp || []
                                this.ajustesCombinado = result.data.ajustesCombinadoECP || result.data.ajustesCombinadoEcp || []
                                this.searched = this.balance
                                this.consol = true
                                this.fgl_combinado = false
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false
                                    this.generado = true
                                    this.f_columnas_ecp()
                                }
                                this.isLoading = false
                            })
                            .catch((error) => {
                                console.error("Error en Reporte Consol:", error)
                                this.error = true
                                this.isLoading = false
                                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar reporte consolidado" : "Error loading consolidated report")
                            })
                    }
                    
                    // ===== INFORMACION (VALOR MANUAL) =====
                    if (this.Informacion) {
                        Balance.getReporteEcpInformacion(this.idCompania, this.vigencia, this.codReporte, this.$store.state.userId)
                            .then((result) => {
                                this.balance = result.data.informacionManual
                                this.searched = this.balance
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false
                                    this.generado = true
                                }
                                this.isLoading = false
                            })
                            .catch((error) => {
                                console.error("Error en Información:", error)
                                this.error = true
                                this.isLoading = false
                                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar información manual" : "Error loading manual information")
                            })
                    }
                    
                    // ===== AJUSTE CONSOL =====
                    if (this.InfAjusteConsol) {
                        Balance.getReporteEcpInformacionConsol(this.idCompania, this.vigencia, this.codReporte, this.$store.state.userId)
                            .then((result) => {
                                this.balance = result.data.informacionManual
                                this.searched = this.balance
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false
                                    this.generado = true
                                }
                                this.isLoading = false
                            })
                            .catch((error) => {
                                console.error("Error en Inf. Consolidado:", error)
                                this.error = true
                                this.isLoading = false
                                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar información consolidada" : "Error loading consolidated information")
                            })
                    }
                    
                    // ===== AJUSTE COMBINADO =====
                    if (this.InfAjusteComb) {
                        Balance.getReporteEcpInformacionComb(this.idCompania, this.vigencia, this.codReporte, this.$store.state.userId)
                            .then((result) => {
                                this.balance = result.data.informacionManual
                                this.searched = this.balance
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false
                                    this.generado = true
                                }
                                this.isLoading = false
                            })
                            .catch((error) => {
                                console.error("Error en Inf. Combinado:", error)
                                this.error = true
                                this.isLoading = false
                                this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar información combinada" : "Error loading combined information")
                            })
                    }
                    break
            }
        },
        
        cambiaConsolidacion() {
            this.consol = true
            this.fgl_combinado = false
            this.balance = this.searched
        },
        cambiaAjuste() {
            if (this.consol) {
                this.consol = false
                this.fgl_combinado = false
                this.balance = this.ajustes || []
            } else {
                this.consol = true
                this.fgl_combinado = false
                this.balance = this.searched
            }
        },
        cambiaCombinado() {
            this.consol = true
            this.fgl_combinado = true
            this.balance = this.combinado || []
        },
        cambiaAjusteCombinado() {
            this.consol = false
            this.fgl_combinado = true
            this.balance = this.ajustesCombinado || []
        },
        f_columnas_ecp() {
            if (this.ecpcolumnas && this.ecpcolumnas.length > 0) {
                for (let idx = 0; idx < this.maxcolumnas; idx++) {
                    this.titulo_columna_ecp[idx] = this.ecpcolumnas[idx].descripcion.substring(0, 20)
                }
            }
        },
        f_muestraConsol(r_informacion) {
            if (r_informacion && r_informacion.length > 0) {
                this.showDialogInformacionConsol = true
                this.formInformacionConsol = { ...r_informacion[0] }
            }
        },
        f_muestraComb(r_informacion) {
            if (r_informacion && r_informacion.length > 0) {
                this.showDialogInformacionComb = true
                this.formInformacionComb = { ...r_informacion[0] }
            }
        },
        f_grabaInformacionConsol() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error(this.$store.state._language == "es-ES" ? 'La vigencia seleccionada está deshabilitada para edición.' : 'The selected validity is disabled for editing.')
                return
            }
            this.formInformacionConsol.u_modifica = this.$store.state.userId
            this.showDialogInformacionConsol = false
            Balance.grabaEcpInformacionConsol(this.idCompania, this.vigencia, this.codReporte, this.formInformacionConsol)
                .then((result) => {
                    if (result.status == 200) {
                        this.$toast.success(this.$store.state._language == "es-ES" ? "Información Grabada" : "Information Saved")
                        this.generar()
                    } else {
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Problema al grabar" : "Problem saving")
                    }
                })
                .catch(() => {
                    this.error = true
                    this.$toast.error(this.$store.state._language == "es-ES" ? "Error al grabar" : "Error saving")
                })
        },
        f_grabaInformacionComb() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error(this.$store.state._language == "es-ES" ? 'La vigencia seleccionada está deshabilitada para edición.' : 'The selected validity is disabled for editing.')
                return
            }
            this.formInformacionComb.u_modifica = this.$store.state.userId
            this.showDialogInformacionComb = false
            Balance.grabaEcpInformacionComb(this.idCompania, this.vigencia, this.codReporte, this.formInformacionComb)
                .then((result) => {
                    if (result.status == 200) {
                        this.$toast.success(this.$store.state._language == "es-ES" ? "Información Grabada" : "Information Saved")
                        this.generar()
                    } else {
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Problema al grabar" : "Problem saving")
                    }
                })
                .catch(() => {
                    this.error = true
                    this.$toast.error(this.$store.state._language == "es-ES" ? "Error al grabar" : "Error saving")
                })
        },
        excel(opcion) {
            let datos = {}
            datos.titulo = this.tituloConsolidado
            if (opcion === 4) {
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEcpInformacion(datos)
            }
            if (opcion === 5) {
                datos.opcion = 5
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.maxcolumnas = this.maxcolumnas
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEcp(datos)
            }
            if (opcion === 6) {
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEcpInformacion(datos)
            }
            if (opcion === 7) {
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEcpInformacion(datos)
            }
        },
        async hojaExcelReporteEcpInformacion() {},
        async hojaExcelReporteEcp() {},
        formato(numero) {
            if (numero === null || numero === undefined) return ''
            if (typeof numero === 'string') numero = parseFloat(numero) || 0
            return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })?.format(numero)
        },
        descargar() {
            const link = document.createElement('a')
            link.href = this.rutaExcel
            link.target = '_blank'
            link.download = this.rutaExcel
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        f_fila(p_fila) {
            if (!this.ecpfilas || this.ecpfilas.length === 0) return ''
            let fila = this.ecpfilas.filter(fila => fila.fila == p_fila)
            return fila?.length > 0 ? fila[0]?.descripcion : ''
        },
        f_muestra(r_informacion) {
            if (r_informacion && r_informacion.length > 0) {
                this.formInformacion = { ...r_informacion[0] }
                this.showDialogInformacion = true
            }
        },
        f_grabaInformacion() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error(this.$store.state._language == "es-ES" ? 'La vigencia seleccionada está deshabilitada para edición.' : 'The selected validity is disabled for editing.')
                return
            }
            this.formInformacion.u_modifica = this.$store.state.userId
            this.showDialogInformacion = false
            Balance.grabaEcpInformacion(this.idCompania, this.vigencia, this.codReporte, this.formInformacion)
                .then((result) => {
                    if (result.status == 200) {
                        this.$toast.success(this.$store.state._language == "es-ES" ? "Información Grabada" : "Information Saved")
                        this.generar()
                    } else {
                        this.$toast.error(this.$store.state._language == "es-ES" ? "Problema al grabar" : "Problem saving")
                    }
                })
                .catch(() => {
                    this.error = true
                    this.$toast.error(this.$store.state._language == "es-ES" ? "Error al grabar" : "Error saving")
                })
        },
        editaInfoBalance() {},
        editaInfoBalanceConsol() {},
        editaInfoBalanceComb() {},
        
        // ==== Métodos de inicialización ====
        getNombreMonedaConsolidado(tipo = 'funcional1') {
            const funcionalEsperada = tipo === 'funcional2' ? 2 : 1
            const moneda = (this.currency || []).find((item) => Number(item.isFuncional) === funcionalEsperada)
            if (!moneda) return ''
            return moneda?.nombre || moneda?.acronimo || ''
        },
        getMonedaConsolidadoParametro() {
            return this.monedaConsolidadoSeleccion === 'funcional2' ? 2 : 1
        },
        normalizaSelectorMonedaConsolidado() {
            const opciones = this.monedaConsolidadoOptions.map((item) => item.value)
            if (opciones.length === 0) { 
                this.monedaConsolidadoSeleccion = 'funcional1'
                return
            }
            if (!opciones.includes(this.monedaConsolidadoSeleccion)) {
                this.monedaConsolidadoSeleccion = opciones[0]
            }
        },
        async loadButtonControlsFromDb() {
            const defaultControls = {
                Reporte: true, ReporteConsol: true, Informacion: true,
                InfAjusteConsol: true, InfAjusteComb: true,
                SelectorMoneda: true, MonedaFuncional1: true, MonedaFuncional2: true
            }
            const controlMap = {
                700: "Reporte", 710: "ReporteConsol", 720: "Informacion",
                730: "InfAjusteConsol", 740: "InfAjusteComb",
                600: "SelectorMoneda", 610: "MonedaFuncional1", 620: "MonedaFuncional2"
            }
            try {
                const roleId = Number(this.$store.state.userRole) || 0
                const response = await BotonesControl.getBotonesControl("REPORTEECP", roleId)
                const botones = Array.isArray(response.data.botones) ? response.data.botones : []
                const controls = { ...defaultControls }
                botones.forEach((item) => {
                    const key = controlMap[Number(item.id_boton)]
                    if (!key) return
                    controls[key] = item.enabled !== false
                })
                this.$store.commit("setComponentControls", { componentName: "ReporteECP", controls })
            } catch (error) {
                console.log("Error cargando visibilidad de botones ECP:", error)
            } finally {
                this.normalizaSelectorMonedaConsolidado()
            }
        },
        onFiltroChange() {
            this.isEmpty = true
            this.generado = false
            this.balance = []
            this.searched = []
            this.ajustes = []
            this.combinado = []
            this.ajustesCombinado = []
        },
        onCambioMonedaConsolidado() {
            this.normalizaSelectorMonedaConsolidado()
            if (this.ReporteConsol && this.generado) this.generar()
        },
        getCampoValorReporteEcp(index = 1) {
            if (this.ReporteConsol) {
                return this.monedaConsolidadoSeleccion === 'funcional2' ? `prom${index}_m2` : `prom${index}`
            }
            return `val${index}`
        },
        filtraCompaniasPorGrupo() {
            this.isEmpty = true
            this.dialogCompanias = null
            if (this.grupoId === 'todos' || !this.grupoId) {
                this.companiasFiltradas = [...this.companias]
            } else {
                const grupoIdStr = this.grupoId.toString()
                this.companiasFiltradas = this.companias.filter(compania => {
                    if (!compania?.id_grupos) return false
                    const gruposCompania = compania.id_grupos.split(',').map(id => id.trim())
                    return gruposCompania?.includes(grupoIdStr)
                })
            }
        },
        seleccionaCompania() {
            this.isEmpty = true
            let buscaMoneda = this.companias.filter((item) => item.id == this.dialogCompanias)
            if (buscaMoneda.length > 0) {
                this.moneda = buscaMoneda[0].acronimo
            }
        },
        goBack() {
            this.$router.back()
        },
        f_titulo() {
            // Título fijo siempre igual
            if (this.$store.state._language == "es-ES") {
                this.tituloConsolidado = "Estado de cambios en el Patrimonio"
            } else {
                this.tituloConsolidado = "CHANGE IN EQUITY"
            }
        },
        f1_titulo() {
            return "CUENTAS CONTABLES " + (this.formCuentas.descripcion || '')
        }
    },
    async mounted() {
        this.isLoading = true
        await this.loadButtonControlsFromDb()
        try {
            const resultCompaniaUsuario = await Balance.leaCompaniaUsuario()
            this.companiaUsuario = resultCompaniaUsuario.data.companiaUsuario || []
        } catch {
            this.error = true
            this.companiaUsuario = []
        }
        try {
            const resultCompanias = await Balance.getCompanias(true)
            this.companias = resultCompanias.data.companias
            this.companiasFiltradas = [...this.companias]
            this.dialogCompanias = ''
            this.codigoCompanias = "{"
            let primero = true
            let v_companias = []
            resultCompanias.data.companias.forEach((element) => {
                const v_usuario = this.companiaUsuario.find((r_usuario) =>
                    r_usuario.id_usuario == this.$store.state.userId &&
                    r_usuario.id_compania == element.id)
                if (this.$store.state.userRole == 1 || v_usuario) {
                    v_companias.push(element)
                }
            })
            this.companias = v_companias
            this.companiasFiltradas = [...this.companias]
            resultCompanias.data.companias.forEach(element => {
                if (!primero) this.codigoCompanias = this.codigoCompanias + ","
                primero = false
                this.codigoCompanias = this.codigoCompanias + "\"id" + element.id + "\":" + "\"" + element.codigo + "\""
            })
            this.codigoCompanias = this.codigoCompanias + "}"
            this.codigoCompanias = JSON.parse(this.codigoCompanias)
        } catch {
            this.error = true
        }
        Balance.getFechas()
            .then((result) => {
                this.fechas = result.data.fechas
                this.dialogFechas = ''
            })
            .catch(() => { this.error = true })
        Balance.getReportes()
            .then((result) => {
                this.reportes = result.data.reportes
            })
            .catch(() => { this.error = true })
        Currency.getAllCurrency()
            .then((result) => {
                this.currency = result.data.currency || []
                this.normalizaSelectorMonedaConsolidado()
            })
            .catch(() => { this.error = true })
        Grupo.getAllGrupos()
            .then((result) => {
                this.listGrupos = result.data.grupos
                this.grupoId = 'todos'
            })
            .catch(() => { this.error = true })
        Balance.getEcpFilas()
            .then((result) => {
                this.ecpfilas = result.data.filas
            })
            .catch(() => { this.error = true })
        Balance.getEcpColumnas()
            .then((result) => {
                this.ecpcolumnas = result.data.columnas
                this.maxcolumnas = this.ecpcolumnas.length
            })
            .catch(() => { this.error = true })
        this.isLoading = false
        this.f_titulo()
    },
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ========== ESTILOS DE FILTROS PRINCIPALES ========== */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

/* ========== DROPDOWN DE SELECCIÓN ÚNICA ========== */
.filter-dropdown {
    display: inline-block;
}

.filter-dropdown .filter-dropdown-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: transparent !important;
    color: #6c757d !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.filter-dropdown .filter-dropdown-btn:hover:not(:disabled) {
    background-color: #6c757d !important;
    color: white !important;
}

.filter-dropdown .filter-dropdown-btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5) !important;
}

.filter-dropdown .filter-dropdown-btn::after {
    margin-left: 8px;
}

.filter-dropdown .dropdown-item.active {
    background-color: #1f4f83 !important;
    color: white !important;
}

.filter-dropdown .dropdown-item:hover:not(.active) {
    background-color: #e9ecef !important;
}

/* ========== BOTÓN GENERAR ========== */
.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover:not(:disabled) {
    background-color: #5a6268 !important;
    border-color: #545b62 !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== BOTONES DE REPORTE CONSOL (en el toolbar) ========== */
.reporte-consol-tabs-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
}

.reporte-consol-tabs-wrapper .tab-btn-origin-dest {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    flex-shrink: 0;
    border: 1px solid #ced4da;
    transition: all 0.2s;
    background-color: transparent;
    color: #495057;
}

.reporte-consol-tabs-wrapper .tab-btn-origin-dest.tab-active {
    background-color: #1f4f83 !important;
    border-color: #1f4f83 !important;
    color: white !important;
}

.reporte-consol-tabs-wrapper .tab-btn-origin-dest.tab-active:hover:not(:disabled) {
    background-color: #1a446f !important;
    border-color: #1a446f !important;
}

.reporte-consol-tabs-wrapper .tab-btn-origin-dest.tab-active:focus:not(:disabled) {
    box-shadow: 0 0 0 0.2rem rgba(31, 79, 131, 0.5) !important;
}

.reporte-consol-tabs-wrapper .tab-btn-origin-dest.tab-inactive {
    background-color: transparent !important;
    border-color: #ced4da !important;
    color: #495057 !important;
}

.reporte-consol-tabs-wrapper .tab-btn-origin-dest.tab-inactive:hover:not(:disabled) {
    background-color: #e9ecef !important;
    color: #212529 !important;
}

.reporte-consol-tabs-wrapper .tab-btn-origin-dest:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ========== ESTILOS DE FLECHA Y TÍTULO ========== */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

/* ========== TOOLBAR ========== */
.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.niif-toolbar-right .table-toolbar-export-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #1f4f83 !important;
    color: white !important;
    border: 1px solid #1f4f83 !important;
}

.niif-toolbar-right .table-toolbar-export-btn:hover:not(:disabled) {
    background-color: #1a446f !important;
    border-color: #1a446f !important;
}

.niif-toolbar-right .table-toolbar-export-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== MODALES ========== */
.modal-header-custom {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    padding: 12px 20px;
}

.modal-footer-custom {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 12px 20px;
}

/* ========== ESTILOS DEL MODAL DE EMPRESAS ========== */
.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.custom-scroll-table {
    height: 250px;
    min-height: 250px;
    max-height: 350px;
    overflow-y: auto;
    position: relative;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}
/* ========== RESPONSIVE ========== */
@media (max-width: 1200px) {
    .niif-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }
    
    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
    
    .reporte-consol-tabs-wrapper .tab-btn-origin-dest {
        height: 30px;
        min-height: 30px;
        font-size: 12px;
        padding: 0 12px;
    }
}

@media (max-width: 992px) {
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }
    
    .niif-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }
    
    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
    
    .reporte-consol-tabs-wrapper {
        flex-wrap: wrap;
    }
    
    .reporte-consol-tabs-wrapper .tab-btn-origin-dest {
        flex: 1;
        min-width: 80px;
        height: 30px;
        min-height: 30px;
        font-size: 12px;
        padding: 0 10px;
    }
}

@media (max-width: 768px) {
    .niif-toolbar-right {
        flex-wrap: wrap;
        justify-content: flex-start;
    }
    
    .reporte-consol-tabs-wrapper {
        width: 100%;
        justify-content: flex-start;
    }
    
    .reporte-consol-tabs-wrapper .tab-btn-origin-dest {
        flex: 0 0 auto;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }
    
    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }
    
    .niif-header .filters-container {
        gap: 4px;
    }
    
    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
        font-size: 13px;
        padding: 0 16px;
    }

    .reporte-consol-tabs-wrapper {
        flex-wrap: wrap;
        width: 100%;
    }
    
    .reporte-consol-tabs-wrapper .tab-btn-origin-dest {
        flex: 1 1 auto;
        min-width: 60px;
        height: 28px;
        min-height: 28px;
        font-size: 11px;
        padding: 0 8px;
    }
}
</style>